
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $d2e25891a8cd0e59$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["ksAJF","index.e948160f.js","6O8RJ","image-product-1-thumbnail.4644d4bd.jpg","2JXIC","icon-minus.1c927acc.svg","lIw2C","icon-plus.e6904ca9.svg","gXoxX","image-product-1.4f5deaf7.jpg","gThDR","image-product-2.26974f01.jpg","enPLp","image-product-3.1f3a9183.jpg","aIrl4","image-product-4.0c4028d7.jpg","eD5Cs","image-product-1-thumbnail.4644d4bd.jpg","gBUal","image-product-2-thumbnail.273df9ad.jpg","i0EQX","image-product-3-thumbnail.340480a5.jpg","f6s6v","image-product-4-thumbnail.c4315272.jpg"]'));

var $135ea58e6cc10089$exports = {};
$135ea58e6cc10089$exports = new URL("image-product-1-thumbnail.4644d4bd.jpg", import.meta.url).toString();


class $17593383745bf7e2$export$494d083da011ade5 {
    constructor(parentElement, btnElement){
        this.parentElement = parentElement;
        this.btnElement = btnElement;
        this.items = [];
        this.renderModal();
        this.modalContentElement = this.modalElement.querySelector(".cart-modal__content");
        this.modalContentElement.addEventListener("click", this.onClickRemove.bind(this));
        btnElement.addEventListener("click", ()=>{
            this.modalElement.classList.toggle("cart-modal--show");
        });
        window.addEventListener("click", (e)=>{
            const targetElement = e.target;
            if (targetElement.closest(".cart-btn")) return;
            if (!targetElement.closest(".cart-modal--show") && this.modalElement.classList.contains("cart-modal--show")) this.modalElement.classList.remove("cart-modal--show");
        });
    }
    static createItem(amount = 1) {
        return {
            id: Math.floor(Date.now() * Math.random()),
            productName: "Fall Limited Edition Sneakers",
            price: 125.0,
            amount: amount
        };
    }
    calcTotalAmount() {
        return this.items.reduce((acc, cur)=>acc + cur.amount, 0);
    }
    addToCart(item) {
        this.items.push(item);
        if (this.items.length === 1) this.renderCart();
        const itemMarkup = `
            <img class="cart-modal__item-img" src="${(0, (/*@__PURE__*/$parcel$interopDefault($135ea58e6cc10089$exports)))}" alt="Sneakers image" />
            <div>
                <p class="cart-modal__item-name">Fall Limited Edition Sneakers</p>
                <p class="cart-modal__item-price">$${item.price.toFixed(2)} x ${item.amount} <span class="cart-modal__item-price--total">$${(item.price * item.amount).toFixed(2)}</span></p>
            </div>
            <button class="cart-modal__remove-item-btn" aria-label="Remove item from cart button">
                <svg class="cart-modal__remove-item-icon" width="14" height="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 2.625V1.75C0 1.334.334 1 .75 1h3.5l.294-.584A.741.741 0 0 1 5.213 0h3.571a.75.75 0 0 1 .672.416L9.75 1h3.5c.416 0 .75.334.75.75v.875a.376.376 0 0 1-.375.375H.375A.376.376 0 0 1 0 2.625Zm13 1.75V14.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 14.5V4.375C1 4.169 1.169 4 1.375 4h11.25c.206 0 .375.169.375.375ZM4.5 6.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Zm3 0c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Zm3 0c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Z" id="a"/></defs><use fill-rule="nonzero" xlink:href="#a"/></svg>
            </button>
        `;
        const itemElement = document.createElement("li");
        itemElement.innerHTML = itemMarkup;
        itemElement.dataset.itemId = item.id.toString();
        itemElement.classList.add("cart-modal__list-item");
        itemElement.classList.add("fade-in");
        itemElement.addEventListener("animationend", ()=>itemElement.classList.remove("fade-in"));
        this.modalContentElement.querySelector(".cart-modal__list").append(itemElement);
        this.renderAmount();
    }
    removeFromCart(removeId) {
        this.items = this.items.filter((item)=>item.id !== removeId);
        const removeElement = this.modalContentElement.querySelector(`[data-item-id="${removeId}"]`);
        removeElement?.classList.add("fade-out");
        removeElement?.addEventListener("animationend", ()=>{
            if (this.items.length === 0) this.renderCart();
            removeElement?.remove();
        });
        this.renderAmount();
    }
    getItems() {
        return this.items;
    }
    onClickRemove(e) {
        const target = e.target;
        if (!e.target || !target.closest("button")) return;
        const listItemElement = target.closest(".cart-modal__list-item");
        const itemId = +listItemElement.dataset.itemId;
        this.removeFromCart(itemId);
    }
    renderAmount() {
        const cartAmountElement = this.btnElement.querySelector(".cart-btn__amount");
        const totalAmount = this.calcTotalAmount();
        if (totalAmount === 0) cartAmountElement.classList.remove("cart-btn__amount--show");
        else {
            cartAmountElement.textContent = totalAmount.toString();
            cartAmountElement.classList.add("cart-btn__amount--show");
        }
    }
    renderModal() {
        this.modalElement = document.createElement("div");
        this.modalElement.classList.add("cart-modal");
        this.modalElement.innerHTML = `
            <div class="cart-modal__title">
                <p>Cart</p>
            </div>
            <div class="cart-modal__content">
                <p>Your cart is empty</p>
            </div>
        `;
        this.parentElement.append(this.modalElement);
    }
    renderCart() {
        let markup;
        if (this.items.length === 0) markup = `<p>Your cart is empty</p>`;
        else markup = `
                <ul class="cart-modal__list"></ul>
                <button class="btn fade-in" aria-label="Checkout button">Checkout</button>
            `;
        this.modalContentElement.innerHTML = markup;
    }
}


var $1bebaf817576bd54$exports = {};
$1bebaf817576bd54$exports = new URL("icon-minus.1c927acc.svg", import.meta.url).toString();


var $6930e72c36860725$exports = {};
$6930e72c36860725$exports = new URL("icon-plus.e6904ca9.svg", import.meta.url).toString();


class $1a195ef33c4edc24$export$ba4813f621de6647 {
    constructor(parentElement, cart){
        this.parentElement = parentElement;
        this.cart = cart;
        this.maxValue = 9;
        this.minValue = 0;
        this.value = 0;
        this.render();
        this.formElement = parentElement.querySelector(".cart-form");
        this.inputElement = parentElement.querySelector(".cart-form__amount-input");
        this.addToCartBtnElement = parentElement.querySelector(".btn--add-to-cart");
        if (this.inputElement.max) this.maxValue = +this.inputElement.max;
        if (this.inputElement.min) this.minValue = +this.inputElement.min;
        this.formElement.addEventListener("submit", this.onFormSubmit.bind(this));
        this.addToCartBtnElement.addEventListener("click", this.onAddToCartClick.bind(this));
        this.inputElement.addEventListener("change", this.onChange.bind(this));
        parentElement.querySelector(".cart-form__amount-btn--increment").addEventListener("click", this.onIncrement.bind(this));
        parentElement.querySelector(".cart-form__amount-btn--decrement").addEventListener("click", this.onDecrement.bind(this));
    }
    getAmount() {
        return this.value;
    }
    reset() {
        this.value = 0;
        this.updateElement();
    }
    addToCart() {
        if (this.getAmount() <= 0) return;
        this.cart.addToCart((0, $17593383745bf7e2$export$494d083da011ade5).createItem(this.getAmount()));
        this.reset();
    }
    onAddToCartClick() {
        this.addToCart();
    }
    onFormSubmit(e) {
        e.preventDefault();
        this.addToCart();
    }
    updateElement() {
        this.inputElement.value = this.value === 0 ? "" : this.value.toString();
    }
    onChange() {
        if (+this.inputElement.value > this.maxValue || +this.inputElement.value < this.minValue) this.inputElement.value = "1";
        this.value = +this.inputElement.value;
    }
    onIncrement() {
        if (this.value >= this.maxValue) return;
        this.value++;
        this.updateElement();
    }
    onDecrement() {
        if (+this.value <= this.minValue) return;
        this.value--;
        this.updateElement();
    }
    render() {
        const markup = `
            <form class="cart-form" action="#" method="post" novalidate>
                <div class="cart-form__amount">
                    <button class="cart-form__amount-btn cart-form__amount-btn--decrement" aria-label="Decrease items button" type="button">
                        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($1bebaf817576bd54$exports)))}" alt="Minus icon" />
                    </button>
                    <input class="cart-form__amount-input" type="number" name="product-amount" id="product-amount" min="0" max="9" placeholder="0" aria-label="Amount of items" />
                    <button class="cart-form__amount-btn cart-form__amount-btn--increment" aria-label="Increase items button" type="button">
                        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($6930e72c36860725$exports)))}" alt="Plus icon" />
                    </button>
                </div>
                <button class="btn btn--add-to-cart" aria-label="Add item to cart button">
                    <svg viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg"><path d="M20.925 3.641H3.863L3.61.816A.896.896 0 0 0 2.717 0H.897a.896.896 0 1 0 0 1.792h1l1.031 11.483c.073.828.52 1.726 1.291 2.336C2.83 17.385 4.099 20 6.359 20c1.875 0 3.197-1.87 2.554-3.642h4.905c-.642 1.77.677 3.642 2.555 3.642a2.72 2.72 0 0 0 2.717-2.717 2.72 2.72 0 0 0-2.717-2.717H6.365c-.681 0-1.274-.41-1.53-1.009l14.321-.842a.896.896 0 0 0 .817-.677l1.821-7.283a.897.897 0 0 0-.87-1.114ZM6.358 18.208a.926.926 0 0 1 0-1.85.926.926 0 0 1 0 1.85Zm10.015 0a.926.926 0 0 1 0-1.85.926.926 0 0 1 0 1.85Zm2.021-7.243-13.8.81-.57-6.341h15.753l-1.383 5.53Z" fill-rule="nonzero"/></svg>
                    Add to cart
                </button>
            </form>
        `;
        this.parentElement.insertAdjacentHTML("beforeend", markup);
    }
}


class $fdb5bc6b793aa3cd$export$698223c589197ab7 {
    static create(clickedCallback = ()=>{}) {
        return new $fdb5bc6b793aa3cd$export$698223c589197ab7(clickedCallback);
    }
    constructor(clickedCallback){
        this.clickedCallback = clickedCallback;
        this.onClickBackdrop = ()=>{
            this.remove();
        };
        this.onFadeAnimationEnd = ()=>{
            this.backdropElement.remove();
        };
        this.backdropElement = document.createElement("div");
        this.backdropElement.classList.add("backdrop");
        this.backdropElement.classList.add("fade-in");
        document.body.append(this.backdropElement);
        this.backdropElement.addEventListener("click", this.onClickBackdrop);
    }
    remove(callback = true) {
        this.backdropElement.classList.add("fade-out");
        this.backdropElement.addEventListener("animationend", this.onFadeAnimationEnd);
        if (callback) this.clickedCallback();
    }
}




var $5297cf19cea10528$exports = {};
$5297cf19cea10528$exports = new URL("image-product-1.4f5deaf7.jpg", import.meta.url).toString();


var $8de801161f28b8cc$exports = {};
$8de801161f28b8cc$exports = new URL("image-product-2.26974f01.jpg", import.meta.url).toString();


var $c7cdcd1d7cb5c590$exports = {};
$c7cdcd1d7cb5c590$exports = new URL("image-product-3.1f3a9183.jpg", import.meta.url).toString();


var $23a0a09021a5bcd7$exports = {};
$23a0a09021a5bcd7$exports = new URL("image-product-4.0c4028d7.jpg", import.meta.url).toString();


var $7989968454bdf576$exports = {};
$7989968454bdf576$exports = new URL("image-product-1-thumbnail.4644d4bd.jpg", import.meta.url).toString();


var $ae6e41dcdcd0024d$exports = {};
$ae6e41dcdcd0024d$exports = new URL("image-product-2-thumbnail.273df9ad.jpg", import.meta.url).toString();


var $184c7c718ddbfc9f$exports = {};
$184c7c718ddbfc9f$exports = new URL("image-product-3-thumbnail.340480a5.jpg", import.meta.url).toString();


var $6eb59f5fc51a6b02$exports = {};
$6eb59f5fc51a6b02$exports = new URL("image-product-4-thumbnail.c4315272.jpg", import.meta.url).toString();


const $757a7b69fd4dfc8c$var$SMALL_SCREEN_WIDTH = 768;
class $757a7b69fd4dfc8c$export$ace63239d21d36e {
    static create(parentElement) {
        return new $757a7b69fd4dfc8c$export$ace63239d21d36e(parentElement);
    }
    constructor(parentElement, isLightbox = false){
        this.parentElement = parentElement;
        this.isLightbox = isLightbox;
        this.images = [
            {
                imgPath: (0, (/*@__PURE__*/$parcel$interopDefault($5297cf19cea10528$exports))),
                thumbPath: (0, (/*@__PURE__*/$parcel$interopDefault($7989968454bdf576$exports))),
                alt: "Sneakers"
            },
            {
                imgPath: (0, (/*@__PURE__*/$parcel$interopDefault($8de801161f28b8cc$exports))),
                thumbPath: (0, (/*@__PURE__*/$parcel$interopDefault($ae6e41dcdcd0024d$exports))),
                alt: "Sneakers"
            },
            {
                imgPath: (0, (/*@__PURE__*/$parcel$interopDefault($c7cdcd1d7cb5c590$exports))),
                thumbPath: (0, (/*@__PURE__*/$parcel$interopDefault($184c7c718ddbfc9f$exports))),
                alt: "Sneakers"
            },
            {
                imgPath: (0, (/*@__PURE__*/$parcel$interopDefault($23a0a09021a5bcd7$exports))),
                thumbPath: (0, (/*@__PURE__*/$parcel$interopDefault($6eb59f5fc51a6b02$exports))),
                alt: "Sneakers"
            }
        ];
        this.selectedImageIndex = 0;
        this.render();
        if (this.isLightbox) this.galleryElement.querySelector(".gallery__close-btn").addEventListener("click", ()=>this.remove());
        this.largeImageContainerElement = this.galleryElement.querySelector(".gallery__large-images");
        this.carouselElement = this.galleryElement.querySelector(".gallery__carousel");
        this.thumbsDivElement = this.galleryElement.querySelector(".gallery__thumbs");
        this.thumbsDivElement.addEventListener("click", this.onClickThumbnail.bind(this));
        this.thumbsDivElement.addEventListener("keydown", this.onClickThumbnail.bind(this));
        this.galleryElement.querySelector(".gallery__btn--previous").addEventListener("click", this.previousImage.bind(this));
        this.galleryElement.querySelector(".gallery__btn--next").addEventListener("click", this.nextImage.bind(this));
        this.largeImageContainerElement.addEventListener("click", ()=>{
            if (this.isLightbox || window.innerWidth < $757a7b69fd4dfc8c$var$SMALL_SCREEN_WIDTH) return;
            new $757a7b69fd4dfc8c$export$ace63239d21d36e(document.body, true);
        });
    }
    selectImage(index) {
        this.thumbsDivElement.querySelectorAll(".gallery__thumbnail-img").forEach((element)=>{
            const img = element;
            const imgIndex = +img.dataset.imageIndex;
            if (imgIndex === index) element.closest("figure")?.classList.add("gallery__thumbnail--selected");
            else element.closest("figure")?.classList.remove("gallery__thumbnail--selected");
        });
        this.selectedImageIndex = index;
        this.carouselElement.style.transform = `translateX(${-100 * index}%)`;
    }
    nextImage() {
        const newIndex = this.selectedImageIndex < this.images.length - 1 ? this.selectedImageIndex + 1 : 0;
        this.selectImage(newIndex);
    }
    previousImage() {
        const newIndex = this.selectedImageIndex === 0 ? this.images.length - 1 : this.selectedImageIndex - 1;
        this.selectImage(newIndex);
    }
    remove() {
        if (this.backdrop) {
            this.backdrop.remove(false);
            this.backdrop = null;
        }
        this.galleryElement.classList.add("fade-out");
        this.galleryElement.addEventListener("animationend", ()=>{
            this.galleryElement.remove();
        });
    }
    onClickThumbnail(e) {
        if (e.type === "keydown") {
            const keydownEvent = e;
            if (keydownEvent.code !== "Space" && keydownEvent.code !== "Enter") return;
        }
        const target = e.target;
        if (!target) return;
        const imageElement = target.querySelector(".gallery__thumbnail-img") || target;
        if (!imageElement || !imageElement.dataset.imageIndex) return;
        const imageIndex = +imageElement.dataset.imageIndex;
        this.selectImage(imageIndex);
    }
    render() {
        this.galleryElement = document.createElement("div");
        this.galleryElement.classList.add("gallery");
        if (this.isLightbox) {
            this.backdrop = (0, $fdb5bc6b793aa3cd$export$698223c589197ab7).create(()=>this.remove());
            this.galleryElement.classList.add("gallery--lightbox");
            this.galleryElement.classList.add("fade-in");
            this.galleryElement.insertAdjacentHTML("beforeend", `
                <button class="gallery__close-btn" aria-label="Close lightbox button">
                    <svg alt="Close icon" class="gallery__close-icon" xmlns="http://www.w3.org/2000/svg"><path d="m11.596.782 2.122 2.122L9.12 7.499l4.597 4.597-2.122 2.122L7 9.62l-4.595 4.597-2.122-2.122L4.878 7.5.282 2.904 2.404.782l4.595 4.596L11.596.782Z" fill-rule="evenodd"/></svg>
                </button>`);
        }
        const markup = `
            <figure class="gallery__large">
                <div class="gallery__large-images">
                    <div class="gallery__carousel">
                        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($7989968454bdf576$exports)))}" alt="Sneakers image 1" class="gallery__large-img gallery__large-img-loading" data-image-index="0" data-image-src="${(0, (/*@__PURE__*/$parcel$interopDefault($5297cf19cea10528$exports)))}" />
                        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($ae6e41dcdcd0024d$exports)))}" alt="Sneakers image 2" class="gallery__large-img gallery__large-img-loading" data-image-index="1" data-image-src="${(0, (/*@__PURE__*/$parcel$interopDefault($8de801161f28b8cc$exports)))}" />
                        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($184c7c718ddbfc9f$exports)))}" alt="Sneakers image 3" class="gallery__large-img gallery__large-img-loading" data-image-index="2" data-image-src="${(0, (/*@__PURE__*/$parcel$interopDefault($c7cdcd1d7cb5c590$exports)))}" />
                        <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($6eb59f5fc51a6b02$exports)))}" alt="Sneakers image 4" class="gallery__large-img gallery__large-img-loading" data-image-index="3" data-image-src="${(0, (/*@__PURE__*/$parcel$interopDefault($23a0a09021a5bcd7$exports)))}" />
                    </div>
                </div>
                <button class="gallery__btn gallery__btn--previous" aria-label="Previous image button">
                    <svg width="12" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M11 1 3 9l8 8" stroke-width="3" fill="none" fill-rule="evenodd"/></svg>
                </button>
                <button class="gallery__btn gallery__btn--next" aria-label="Next image button">
                    <svg width="13" height="18" xmlns="http://www.w3.org/2000/svg"><path d="m2 1 8 8-8 8" stroke-width="3" fill="none" fill-rule="evenodd"/></svg>
                </button>
            </figure>
            <div class="gallery__thumbs">
                <figure tabindex="0" class="gallery__thumbnail gallery__thumbnail--selected"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($7989968454bdf576$exports)))}" alt="Sneakers thumbnail 1" class="gallery__thumbnail-img" data-image-index="0" /></figure>
                <figure tabindex="0" class="gallery__thumbnail"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($ae6e41dcdcd0024d$exports)))}" alt="Sneakers thumbnail 2" class="gallery__thumbnail-img" data-image-index="1" /></figure>
                <figure tabindex="0" class="gallery__thumbnail"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($184c7c718ddbfc9f$exports)))}" alt="Sneakers thumbnail 3" class="gallery__thumbnail-img" data-image-index="2" /></figure>
                <figure tabindex="0" class="gallery__thumbnail"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($6eb59f5fc51a6b02$exports)))}" alt="Sneakers thumbnail 4" class="gallery__thumbnail-img" data-image-index="3" /></figure>
            </div>`;
        this.galleryElement.insertAdjacentHTML("beforeend", markup);
        this.galleryElement.querySelectorAll(".gallery__large-img").forEach((element)=>{
            const imgElement = element;
            const img = new Image();
            img.src = imgElement.dataset.imageSrc;
            img.onload = ()=>{
                imgElement.src = imgElement.dataset.imageSrc;
                imgElement.classList.remove("gallery__large-img-loading");
            };
        });
        if (this.isLightbox) document.body.append(this.galleryElement);
        else this.parentElement.append(this.galleryElement);
    }
}


const $257ba3995936ae97$var$cart = new (0, $17593383745bf7e2$export$494d083da011ade5)(document.querySelector(".cart-btn__wrapper"), document.querySelector(".cart-btn"));
const $257ba3995936ae97$var$cartForm = new (0, $1a195ef33c4edc24$export$ba4813f621de6647)(document.querySelector(".product__buy"), $257ba3995936ae97$var$cart);
(0, $757a7b69fd4dfc8c$export$ace63239d21d36e).create(document.querySelector(".product__gallery"));
let $257ba3995936ae97$var$backdrop;
document.querySelector(".nav-btn")?.addEventListener("click", ()=>{
    document.querySelector(".navigation")?.classList.toggle("navigation--show");
    $257ba3995936ae97$var$backdrop = (0, $fdb5bc6b793aa3cd$export$698223c589197ab7).create(()=>document.querySelector(".navigation")?.classList.remove("navigation--show"));
});
document.querySelector(".navigation__close-btn")?.addEventListener("click", ()=>{
    $257ba3995936ae97$var$backdrop.remove(false);
    document.querySelector(".navigation")?.classList.remove("navigation--show");
});


//# sourceMappingURL=index.e948160f.js.map
